import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { PlayMusic } from '../../../ui/icons';
import { useDispatch, useSelector } from "react-redux";
import { getMainVideo } from "../../../store/courseSlice";

const First = () => {
    const { t } = useTranslation();
    const [isOpen, setIsOpen] = useState(false);
    const dispatch = useDispatch();
    const { mainVideo } = useSelector((state) => state.courses);

    useEffect(() => {
        dispatch(getMainVideo());
    }, [dispatch]);

    const styles = {
        img: {
            height: "calc(100vh - 74px)",
            backgroundImage: "linear-gradient(rgba(0, 0, 0, 0.61), rgba(0, 0, 0, 0.61)), url('./images/Main/Background.png')",
            backgroundSize: "cover",
            backgroundPosition: "center"
        },
        wrapper: {
            height: '100%',
            flexDirection: 'column',
            position: 'relative',
        },
        text: {
            zIndex: 1,
        },
        mainText: {
            letterSpacing: '1.2px',
            lineHeight: '110%',
            fontWeight: 600,
        }
    };

    return (
        <>
            {isOpen ? (
                <div className="flex w-full items-center justify-center border-b-[1px] border-solid border-black">
                    <div className="w-full transform transition-all duration-300 ease-in-out scale-95">
                        <video 
                            width="100%" 
                            height="100%" 
                            autoPlay 
                            controls
                            className='w-full object-cover pb-5'
                        >
                            <source src={mainVideo.introductory_video} type="video/mp4"/>
                            {t('video_not_supported')}
                        </video>
                    </div>
                </div>
            ) : (
                <section style={styles.img} className='px-6'>
                    <div style={styles.wrapper} className='flex items-center justify-center relative h-full'>
                        <div className="w-full text" style={styles.text}>
                            <h2 className="text-white text-center text-xl text-[20px] sm:text-[32px] pb-10 header-text">
                                {t('welcome_message.0')}<br/>
                                {t('welcome_message.1')}
                            </h2>
                        </div>
                        <div className='relative d-block'>
                            <button onClick={() => setIsOpen(true)} className='cursor-pointer'>
                                <PlayMusic />
                            </button>
                        </div>
                    </div>
                </section>
            )}
        </>
    );
};

export default First;